<template>
  <v-main class="page-square page-square-main"
          :style="{'background': `url(${background}) center top no-repeat`, 'background-size': '100% auto'}">
    <v-app-bar
        app
        flat
        dense
        dark
        color="transparent"
        prominent
        :height="`${height > 50 ? height : 50}px`"
        v-scroll:#tab="scroll"
    >
      <template #img="{}">
        <v-fade-transition>
          <SquareHeader v-if="height > 130"
                        :mind-cmplt-yn="mindCmpltYn"
                        :mind-weather-score="mindWeatherScore"
                        @setMindWeatherScore="value => mindWeatherScore = value"
          />
        </v-fade-transition>
      </template>
      <template #extension>
        <v-tabs dark hide-slider v-model="tab" class="tabs" background-color="transparent">
          <v-tab replace :ripple="false" class="fs-16">전체</v-tab>
          <v-tab replace :ripple="false" class="fs-16">내가 쓴 글</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-tabs-items v-model="tab" :style="`--add-scroll-height: ${150 - height}px`">
      <!-- 전체 -->
      <SquareList :show="tab === 0"
                  @openInSquare="openInSquare"/>
      <!-- 내가 쓴글 -->
      <SquareList :show="tab === 1"
                  @openInSquare="openInSquare"
                  isMySquare />
    </v-tabs-items>
    <BottomMenu :current="3"/>
    <!-- 유닛상세 모달-->
    <SolutionContainerModal ref="SolutionContainerModal" />
  </v-main>
</template>
<script>
import store from '@/store'
import {mixinAuth, mixinRemote} from '@/mixins'
import SquareHeader from './SquareHeader'
import SquareList from './SquareList'
import BottomMenu from '@/components/layout/BottomMenu'
import SolutionContainerModal from '@/components/layout/SolutionContainerModal'

const headerHeight = 150

export default {
  components: {
    BottomMenu,
    SquareHeader,
    SquareList,
    SolutionContainerModal
  },
  mixins: [mixinAuth, mixinRemote],
  data: () => ({
    tab: 0,
    background: require('@/assets/images/bg_square.png'),
    mindWeatherScore: null,
    height: headerHeight
  }),
  computed: {
    mindCmpltYn() {
      if (!this.solutions.length) return false
      return this.solutions[0].cmpltYn
    },
    mindUnitUseNo() {
      return this.solutions[0].unitUseNo
    }
  },
  watch: {
    mindCmpltYn(nV, oV) {
      if (nV || (oV === null && nV)) {
        this.getUnitDetail()
      }
    }
  },
  beforeCreate () {
    document.documentElement.classList.add('square')
  },
  destroyed () {
    document.documentElement.classList.remove('square')
  },
  created() {
    this.getUnitDetail()
  },
  mounted() {
    this.handleEventWithQuery();
  },
  methods: {
    scroll(e) {
      let h = headerHeight - e.target.scrollTop
      this.height = h < 0 ? 0 : h
    },
    handleEventWithQuery() {
      // if (userAgent.indexOf('android') >= 0 && userAgent.indexOf('dms_user_app') >= 0) {
      const {squareNo=0, tab=0} = this.$route.query
      // 내가쓴글
      if (tab * 1 > 0) {
        this.tab = 1;
      }
      // 댓글
      if (squareNo * 1 > 0) {
        this.goCmntList({item:{squareNo}})
      }
    },
    async getUnitDetail() {
      if (this.mindCmpltYn) {
        await store.dispatch('getUnitUse', this.$_payload({'unitUseNo': this.mindUnitUseNo, 'freeYn': 'Y'}))
            .then(async res => {
              if (res.success) {
                // 유닛상세 리스트
                let detailUnitNo = res.data.unitDtlList[0].unitDtlUseNo
                let params = [
                  { unitUseNo: this.mindUnitUseNo},
                  { unitDtlUseNo: detailUnitNo},
                  { unitDtlPageSeq: '1' },
                  { freeYn: 'Y' }
                ]
                await store.dispatch('getUnitDetailUse', this.$_payload('so', params))
                    .then(res => {
                      if (res.success) {
                        if (res.data.unitDtlQuesList[0].memberUnitDtlReplyList.length) {
                          this.mindWeatherScore = res.data.unitDtlQuesList[0].memberUnitDtlReplyList[0].score
                        } else {
                          this.mindWeatherScore = 0
                        }
                        // this.mindWeatherScore = 7
                      }
                    })
              }
            })
      }
    },
    openInSquare (unitUseNo, freeYn, reg) {
      this.$refs.SolutionContainerModal.openInSquare(unitUseNo, freeYn, reg)
    }
  }
}
</script>
